var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"d-flex flex-column pt-4"},[_c('router-view',{staticClass:"app-view pt-4",class:{ 'container-fluid': _vm.$auth.isAuthenticated }})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }